import { NgModule } from '@angular/core';
import { RaiseInspectionComponent } from './components/raise-inspection/raise-inspection.component';
import { InspectionsOverviewComponent } from './components/inspections-overview/inspections-overview.component';
import { RouterModule, Routes } from '@angular/router';
const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'add-inspection/:InspectionRequestId'
  },
  {
    path: 'add-inspection/new',
    component: RaiseInspectionComponent
  },
  {
    path: 'add-inspection/:InspectionRequestId',
    component: RaiseInspectionComponent
  },
  {
    path: 'inspections-overview',
    component: InspectionsOverviewComponent
  }
];
@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
})
export class InspectionRoutingModule { }
